import { CSSProperties } from 'react';
import styled from 'styled-components';

import BreadcrumbsStyled from '../Breadcrumbs';
import PageActions from '../PageActions';

interface Breadcrumb {
  label: string;
  url?: string;
}

interface Props {
  className?: string;
  title?: string;
  controlBar?: boolean;
  breadcrumbs?: Array<Breadcrumb>;
  style?: CSSProperties;
}

const DEFAULT_CONTENT_HEADER_BREADCRUMBS: NonNullable<Props['breadcrumbs']> = [];
const DEFAULT_CONTENT_HEADER_STYLE: NonNullable<Props['style']> = {};

const ContentHeader = ({
  className = '',
  title = '',
  controlBar = false,
  breadcrumbs = DEFAULT_CONTENT_HEADER_BREADCRUMBS,
  style = DEFAULT_CONTENT_HEADER_STYLE,
}: Props) => (
  <div style={style} className={className}>
    <div>
      <BreadcrumbsStyled breadcrumbs={breadcrumbs} />
      <h1>{title}</h1>
    </div>
    {controlBar && <PageActions />}
  </div>
);

const ContentHeaderStyled = styled(ContentHeader)`
  border: 0.0625rem solid #2685a133; /* tokens-allow: pending design decision */
  border-radius: 0.5rem;
  background: url('/images/content-header-bg.jpg') center center / cover no-repeat;
  padding: 16px 12px 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.5rem;
  gap: 1rem;

  h1 {
    font-size: ${({ theme }) => theme.typography.h1Sb.fontSize};
    font-weight: ${({ theme }) => theme.typography.h1Sb.fontWeight};
    line-height: ${({ theme }) => theme.typography.h1Sb.lineHeight};
    letter-spacing: ${({ theme }) => theme.typography.h1Sb.letterSpacing};
    color: ${({ theme }) => theme.primaryText};
    margin: 0;
  }
`;

export default ContentHeaderStyled;
